export default {
  namespaced: true,
  state     : {
    course_id     : 1,
    course_content: [],

  },
  getters: {
    course_content         : ({course_content}) => course_content,
    course_id              : ({course_id}) => course_id,
    content_by_block_lesson: ({course_content = []}, {}, {}, rootGetters) => {
      const [block_id, lesson_id] = rootGetters['course_info/steps/current_lesson_path'];
      return course_content.find((x) => x.block === block_id && x.lesson === lesson_id);
    },
  },
  mutations: {
    SET_COURSE_ID(state, course_id) {
      state.course_id = course_id;
    },
    SET_COURSE_CONTENT(state, course_content) {
      state.course_content = course_content;
    },
  },
};
